import { GameShell } from './EnvLayout';
import { useAdminMode } from './useAdminMode';
import SurveyGame from './SurveyGame';
import SurveyAdmin from './SurveyAdmin';

/** The survey, plus admin sign-in and an in-survey editor for questions and responses. */
export default function SurveyPage({ title }: { title: string }) {
  const { editing, actions, loginModal } = useAdminMode('Survey');

  return (
    <GameShell title={title} right={actions}>
      {editing ? (
        <div className="mx-auto w-full max-w-3xl px-4 py-6 md:py-10"><SurveyAdmin /></div>
      ) : (
        <SurveyGame />
      )}
      {loginModal}
    </GameShell>
  );
}
